import { Link } from 'react-router-dom';

const curriculum = [
  {
    title: 'Phase 1: Data Literacy & SQL Mastery',
    classes: [
      {
        title: 'Class 1: Introduction to Data Ecosystem',
        sections: [
          {
            label: 'Concepts',
            items: ['Roles in data (Scientist vs. Analyst vs. Engineer), Data Science Lifecycle, and setting up Jupyter Notebooks.'],
          },
          {
            label: 'Deep Dive',
            items: ['Understanding "Ask" phase—how to turn a business problem into a data question.'],
          },
        ],
      },
      {
        title: 'Class 2: Data Literacy & Taxonomy',
        sections: [
          {
            label: 'Concepts',
            items: ['Structured vs. Unstructured data; Nominal, Ordinal, Interval, and Ratio scales.'],
          },
          {
            label: 'Deep Dive',
            items: ['Identifying data biases (selection bias, confirmation bias) in real-world datasets.'],
          },
        ],
      },
      {
        title: 'Class 3: SQL Basics: The Foundation',
        sections: [
          {
            label: 'Concepts',
            items: ['Relational database theory (Tables, Primary Keys).'],
          },
          {
            label: 'Operations',
            items: ['SELECT, AS, DISTINCT, and LIMIT.'],
          },
          {
            label: 'Hands-on',
            items: ['Querying a database of movies to identify unique genres and titles.'],
          },
        ],
      },
      {
        title: 'Class 4: SQL Filtering: Refining Results',
        sections: [
          {
            label: 'Concepts',
            items: ['Logic in SQL.'],
          },
          {
            label: 'Operations',
            items: ['WHERE clause, Comparison operators (=,<>,>), and Boolean logic (AND, OR).'],
          },
          {
            label: 'Hands-on',
            items: ['Filtering movie datasets for specific release years and rating thresholds.'],
          },
        ],
      },
      {
        title: 'Class 5: SQL Pattern Matching & Nulls',
        sections: [
          {
            label: 'Concepts',
            items: ['Working with incomplete or fuzzy data.'],
          },
          {
            label: 'Operations',
            items: ['LIKE (wildcards), IS NULL, IS NOT NULL, and BETWEEN.'],
          },
          {
            label: 'Hands-on',
            items: ['Searching for specific text patterns in a dataset of user emails and names.'],
          },
        ],
      },
      {
        title: 'Class 6: SQL Aggregates I: Summarizing Data',
        sections: [
          {
            label: 'Concepts',
            items: ['Turning rows into insights.'],
          },
          {
            label: 'Operations',
            items: ['COUNT(), SUM(), AVG(), MIN(), and MAX().'],
          },
          {
            label: 'Hands-on',
            items: ['Calculating total revenue and average price of items in an e-commerce database.'],
          },
        ],
      },
      {
        title: 'Class 7: SQL Aggregates II: Grouping & Ordering',
        sections: [
          {
            label: 'Concepts',
            items: ['Segmenting data for comparison.'],
          },
          {
            label: 'Operations',
            items: ['GROUP BY, HAVING, and ORDER BY.'],
          },
          {
            label: 'Hands-on',
            items: ['Finding top 5 most popular product categories using a "Best Sellers" database.'],
          },
        ],
      },
      {
        title: 'Class 8: SQL Joins: Connecting Data',
        sections: [
          {
            label: 'Concepts',
            items: ['Relational mapping.'],
          },
          {
            label: 'Operations',
            items: ['JOIN (Inner Join), Foreign Keys, and combining multiple tables.'],
          },
          {
            label: 'Hands-on',
            items: ['Combining a "Customer" table with an "Orders" table to see who bought what.'],
          },
        ],
      },
    ],
  },
  {
    title: 'Phase 2: Python for Data Analysis',
    classes: [
      {
        title: 'Class 9: Python Basics: Syntax & Data Types',
        sections: [
          {
            label: 'Concepts',
            items: ['Python’s role in Data Science.'],
          },
          {
            label: 'Operations',
            items: ['Variables, Integers, Floats, and Strings.'],
          },
          {
            label: 'Hands-on',
            items: ['Building a script to calculate interest rates and financial constants.'],
          },
        ],
      },
      {
        title: 'Class 10: Python Control Flow: Conditional Logic',
        sections: [
          {
            label: 'Concepts',
            items: ['Automating decision-making.'],
          },
          {
            label: 'Operations',
            items: ['if, elif, else, and Boolean operators.'],
          },
          {
            label: 'Hands-on',
            items: ['Building a "Credit Score Checker" that returns loan eligibility based on user inputs.'],
          },
        ],
      },
      {
        title: 'Class 11: Python Lists: Ordered Sequences',
        sections: [
          {
            label: 'Concepts',
            items: ['Managing collections of data points.'],
          },
          {
            label: 'Operations',
            items: ['List creation, indexing, and slicing ([start:stop]).'],
          },
          {
            label: 'Hands-on',
            items: ['Storing and retrieving weekly stock price data using lists.'],
          },
        ],
      },
      {
        title: 'Class 12: Advanced List Operations',
        sections: [
          {
            label: 'Concepts',
            items: ['Modifying data in bulk.'],
          },
          {
            label: 'Operations',
            items: ['.append(), .remove(), .sort(), and len().'],
          },
          {
            label: 'Hands-on',
            items: ['Creating a dynamic "Inventory Manager" script.'],
          },
        ],
      },
      {
        title: 'Class 13: Python Loops: The for Loop',
        sections: [
          {
            label: 'Concepts',
            items: ['Iterating over datasets.'],
          },
          {
            label: 'Operations',
            items: ['for loops and range() function.'],
          },
          {
            label: 'Hands-on',
            items: ['Calculating mean of a large list of temperatures manually using a loop.'],
          },
        ],
      },
      {
        title: 'Class 14: Python Loops: while and Control',
        sections: [
          {
            label: 'Concepts',
            items: ['Conditional iteration.'],
          },
          {
            label: 'Operations',
            items: ['while loops, break, and continue.'],
          },
          {
            label: 'Hands-on',
            items: ['Simulating a "data stream" that stops once a specific threshold value is reached.'],
          },
        ],
      },
      {
        title: 'Class 15: List Comprehensions',
        sections: [
          {
            label: 'Concepts',
            items: ['Writing "Pythonic" and efficient code.'],
          },
          {
            label: 'Operations',
            items: ['Single-line loops for data transformation.'],
          },
          {
            label: 'Hands-on',
            items: ['Converting a list of prices from USD to EUR using a one-line list comprehension.'],
          },
        ],
      },
      {
        title: 'Class 16: Python Functions: Modularity',
        sections: [
          {
            label: 'Concepts',
            items: ['Packaging logic for reuse.'],
          },
          {
            label: 'Operations',
            items: ['def, parameters, and return values.'],
          },
          {
            label: 'Hands-on',
            items: ['Writing a function that cleans messy string data (removing whitespace/special characters).'],
          },
        ],
      },
    ],
  },
  {
    title: 'Phase 3: Data Visualization & Communication',
    classes: [
      {
        title: 'Class 17: Statistics for Data Science',
        sections: [
          {
            label: 'Concepts',
            items: ['Central tendency and spread.'],
          },
          {
            label: 'Operations',
            items: ['Mean, Median, Mode, Variance, and Standard Deviation.'],
          },
          {
            label: 'Hands-on',
            items: ['Identifying outliers in a dataset of house prices and discussing their impact.'],
          },
        ],
      },
      {
        title: 'Class 18: Data Visualization Principles',
        sections: [
          {
            label: 'Concepts',
            items: ['The "Grammar of Graphics."'],
          },
          {
            label: 'Theory',
            items: ['Color theory, labeling, and choosing between Bar, Line, and Scatter plots.'],
          },
          {
            label: 'Hands-on',
            items: ['Critiquing real-world charts from news articles to find "Data Ink" inefficiencies.'],
          },
        ],
      },
      {
        title: 'Class 19: Exploratory Data Analysis (EDA)',
        sections: [
          {
            label: 'Concepts',
            items: ['How to approach a new dataset.'],
          },
          {
            label: 'Workflow',
            items: ['Inspecting data, finding missing values, and visualizing correlations.'],
          },
          {
            label: 'Hands-on',
            items: ['Performing a guided EDA on a "World Population" dataset.'],
          },
        ],
      },
      {
        title: 'Class 20: Final Capstone: The Data Story',
        sections: [
          {
            label: 'Concepts',
            items: ['Synthesizing SQL, Python, and Visualization.'],
          },
          {
            label: 'Project',
            items: ['Analyze "Hacker News" or "Twitch Streaming" dataset.'],
          },
          {
            label: 'Tasks',
            items: ['Extraction (SQL) → Transformation (Python) → Presentation (Visualization).'],
          },
        ],
      },
    ],
  },
];

const DataScienceFoundations = () => {
  return (
    <div className="bg-white">
      <div className="bg-blue-700 pt-16 pb-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between gap-4 flex-wrap">
            <h1 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              Data Science Foundations
            </h1>
            <Link
              to="/courses"
              className="inline-flex items-center px-4 py-2 rounded-md text-sm font-medium bg-white text-blue-700 hover:bg-blue-50"
            >
              Back to Courses
            </Link>
          </div>
          <p className="mt-4 text-blue-100 max-w-3xl">
            A structured 20-class program covering SQL, Python, statistics, and visualization to build strong data analysis skills.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="space-y-12">
          {curriculum.map((phase) => (
            <div key={phase.title}>
              <h2 className="text-2xl font-bold text-gray-900 mb-6">{phase.title}</h2>
              <div className="grid gap-6">
                {phase.classes.map((cls) => (
                  <div key={cls.title} className="rounded-lg border border-gray-200 bg-white shadow-sm">
                    <div className="p-6">
                      <h3 className="text-xl font-semibold text-gray-900">{cls.title}</h3>
                      <div className="mt-4 space-y-4">
                        {cls.sections.map((section) => (
                          <div key={section.label}>
                            <p className="text-sm font-semibold text-gray-900">{section.label}</p>
                            <ul className="mt-2 space-y-1 text-sm text-gray-600 list-disc pl-5">
                              {section.items.map((item) => (
                                <li key={item}>{item}</li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DataScienceFoundations;
